import { apiUrl } from '../../../lib/api'

export type CatalogTab = 'all' | 'new' | 'saved'
export type CatalogSort = 'newest' | 'price_asc' | 'price_desc'

// A product the catalog announces but the warehouse cannot ship yet (derived
// server-side: sample-born + zero sellable stock). It rides the card's existing
// badge slot so every surface says the same two words.
export const COMING_SOON_LABEL = 'Coming soon'

export type CatalogProduct = {
  id: string
  slug: string
  name: string
  displayCode: string | null
  category: string
  subcategoryId: string | null
  priceUsd: number | null
  coverImageUrl: string | null
  hoverImageUrl: string | null
  isNew: boolean
  isFavorite: boolean
  label: string | null
  /** Dictionary colour for `label`; null falls back to the card's own style. */
  labelColor?: string | null
  cardFacts: string[]
}

export type CatalogSearchState = {
  category?: string
  subcategory?: string
  q?: string
  sort?: CatalogSort
  tab?: CatalogTab
}

export function catalogMediaUrl(value: string | null | undefined): string | null {
  if (!value) return null
  if (/^https?:\/\//i.test(value)) return value
  const apiPrefix = '/api/v1'
  return value.startsWith(apiPrefix)
    ? apiUrl(value.slice(apiPrefix.length))
    : value
}
